import { gql } from '__generated__';

export default gql(`
  query GetParticipantFieldsForImport($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        invoice_prefix
        participant_fields {
          id
          title
          type
          scope
          choices {
            id
            title
          }
          products {
            id
          }
        }
      }
    }
  }
`);
